import React from "react";
import PropTypes from "prop-types";
import { isB2B } from "../../libs/env";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useCustomOrigin } from "../custom_origin/CustomOriginContext";

const ConfirmationModal = ({ isOpen, toggle, onClick, ShowGradingbtn }) => {
  let BtnClass = "btn-sm modal-button";
  let customOrigin = useCustomOrigin();
  if(isB2B.some(domain => customOrigin && customOrigin.includes(domain)))
    {
      BtnClass = "btn-lg btn-warning px-5 rounded-5 py-1";
    }
  return (
    <Modal
    isOpen={isOpen}
    size="lg"
    toggle={toggle}
    className="modal-dialog-centered "
  >
    <ModalBody>
      <h4 className="text-primary">
        <strong>Are you sure?</strong>
      </h4>
      <p>Check that you have answered all the questions before you click submit. After submitting your work, you cannot make any further changes.</p>
    </ModalBody>
    {ShowGradingbtn ? (
        <ModalFooter className="align-items-start" style={{ border: 0 }}>
          <span>
            <button
              type="submit"
              class="btn fw-bold px-4 py-1 rounded-5"
              style={{
                borderColor: "#667085",
                color: "#667085",
                backgroundColor: "rgba(102, 112, 133, 0.1)",
              }}
              onClick={toggle}
            >
              Edit
            </button>
            <p className="pt-1"></p>
          </span>
          <span className="px-2">
            <button
              type="submit"
              onClick={onClick}
              className="btn fw-bold py-1 rounded-5"
              style={{
                borderColor: "#07A889",
                color: "#07A889",
                backgroundColor: "rgba(240, 255, 245, 1)",
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_5072_9379)">
                  <path
                    d="M13.75 6.92858V7.50358C13.7492 8.85134 13.3128 10.1627 12.5058 11.2422C11.6989 12.3217 10.5646 13.1114 9.2721 13.4935C7.97964 13.8757 6.59829 13.8298 5.33404 13.3627C4.0698 12.8956 2.99041 12.0324 2.25685 10.9017C1.52329 9.7711 1.17487 8.43362 1.26355 7.08877C1.35223 5.74393 1.87325 4.46378 2.74892 3.43925C3.6246 2.41471 4.80799 1.70069 6.12262 1.40367C7.43725 1.10665 8.81267 1.24254 10.0438 1.79108M13.75 2.5L7.5 8.75625L5.625 6.88125"
                    stroke="#07A889"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5072_9379">
                    <rect width="15" height="15" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span className="ps-1">Check answers</span>
            </button>
            <p className="fs-sm-12 text-center pt-1" style={{ color: "#4A5567" }}>Free</p>
          </span>
          <span>
            <button
              type="submit"
              onClick={() => {
                onClick({"grade_with_ai":true});
              }}
              className="btn fw-bold py-1 rounded-5 px-4"
              style={{
                borderColor: "#2E58D4",
                color: "#2E58D4",
                backgroundColor: "rgba(46, 88, 212, 0.06)",
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 17 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_8457_8219)">
                  <path
                    d="M3.18783 15.5832V12.0415M3.18783 4.95817V1.4165M1.41699 3.18734H4.95866M1.41699 13.8123H4.95866M9.20866 2.12484L7.98028 5.31862C7.78052 5.83799 7.68065 6.09767 7.52533 6.31611C7.38767 6.5097 7.21852 6.67885 7.02493 6.8165C6.80649 6.97182 6.54681 7.0717 6.02744 7.27146L2.83366 8.49984L6.02744 9.72821C6.54681 9.92797 6.80649 10.0279 7.02493 10.1832C7.21852 10.3208 7.38767 10.49 7.52533 10.6836C7.68065 10.902 7.78052 11.1617 7.98028 11.6811L9.20866 14.8748L10.437 11.6811C10.6368 11.1617 10.7367 10.902 10.892 10.6836C11.0297 10.49 11.1988 10.3208 11.3924 10.1832C11.6108 10.0279 11.8705 9.92797 12.3899 9.72821L15.5837 8.49984L12.3899 7.27146C11.8705 7.0717 11.6108 6.97182 11.3924 6.8165C11.1988 6.67885 11.0296 6.5097 10.892 6.31611C10.7367 6.09767 10.6368 5.83799 10.437 5.31861L9.20866 2.12484Z"
                    stroke="#2E58D4"
                    stroke-width="1.41667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_8457_8219">
                    <rect width="17" height="17" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span className="ps-1">Grade with AI</span>
            </button>
            <p className="fs-sm-12 text-center pt-1" style={{ color: "#4A5567" }}>
              This feature will consume credits
            </p>
          </span>
        </ModalFooter>
      ) : (
        <ModalFooter style={{ border: 0 }}>
          <button
            type="submit"
            class={`btn mx-3 ${BtnClass}`}
            onClick={onClick}
            data-tc="submit-confirm"
          >
            Submit
          </button>
        </ModalFooter>
      )}
  </Modal>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

ConfirmationModal.defaultProps = { isOpen: false, };

export default ConfirmationModal;
